module.exports = __webpack_public_path__ + "img/updated-release.60a168cd.png";